import React from "react";
import { useIntl } from "react-intl";
import SeoHead from "~/components/seo/SeoHead";

export default function PodcastPageSeo() {
  const intl = useIntl();

  return (
    <SeoHead
      title={intl.formatMessage({ defaultMessage: "Listen to the Govlaunch Podcast", id: "d8Vl5k" })}
      description={intl.formatMessage({
        defaultMessage:
          "The Govlaunch podcast shares the stories of local government innovators and their efforts to build better governments.",
        id: "Bxe5m0",
      })}
    />
  );
}
